"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
var _BuySellInstrumentSelector = _interopRequireDefault(require("./BuySellInstrumentSelector"));
require("./BuySellInstrumentSelectComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('buy-sell-select-an-instrument');
var BuySellInstrumentSelectComponent = /*#__PURE__*/function (_React$Component) {
  function BuySellInstrumentSelectComponent() {
    _classCallCheck(this, BuySellInstrumentSelectComponent);
    return _callSuper(this, BuySellInstrumentSelectComponent, arguments);
  }
  _inherits(BuySellInstrumentSelectComponent, _React$Component);
  return _createClass(BuySellInstrumentSelectComponent, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this = this;
      var selectedInstrument = this.props.instruments.find(function (instrument) {
        return instrument.InstrumentId === _this.props.selectedInstrument.InstrumentId;
      });
      if (selectedInstrument || !this.props.instruments[0]) return;
      var instrumentId = this.props.instruments[0].InstrumentId;
      this.props.selectInstrument(instrumentId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var t = this.props.t;
      var _this$props = this.props,
        instruments = _this$props.instruments,
        selectedInstrument = _this$props.selectedInstrument;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('container')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('label')
      }, t("Select an Instrument:")), /*#__PURE__*/_react["default"].createElement("form", null, /*#__PURE__*/_react["default"].createElement(_BuySellInstrumentSelector["default"], {
        name: "instrument",
        options: instruments.map(function (instrument) {
          return {
            label: "".concat(instrument.Product1FullName, " / ").concat(instrument.Product2FullName),
            onClick: function onClick() {
              return _this2.props.onInstrumentSelect(instrument.InstrumentId);
            }
          };
        }),
        instrumentsSymbols: selectedInstrument.Symbol,
        selectedInstrument: "".concat(selectedInstrument.Product1FullName, " / ").concat(selectedInstrument.Product2FullName),
        bemClasses: baseClasses
      })));
    }
  }]);
}(_react["default"].Component);
BuySellInstrumentSelectComponent.propTypes = {
  instruments: _propTypes["default"].array.isRequired,
  clearForm: _propTypes["default"].func.isRequired,
  selectInstrument: _propTypes["default"].func.isRequired,
  selectedInstrument: _propTypes["default"].object.isRequired,
  onInstrumentSelect: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)("core")(BuySellInstrumentSelectComponent);